import { FlexBox } from "@brg/ui";

import {
  CheckBoxWrapper,
  RadioInputSource,
  RadioBox,
  RadioCircle
} from './styles'

const RadioButton = ({ children, ...props } : any) => {
  return (
    <CheckBoxWrapper disabled={props.disabled}>
      <FlexBox width="100%">
        <RadioInputSource {...props as any} type={'radio'}/>
        <RadioBox {...props as any}>
          <RadioCircle {...props as any} />
          <FlexBox width="100%">
            {children}
          </FlexBox>
        </RadioBox>
      </FlexBox>
    </CheckBoxWrapper>
  )
}

export default RadioButton;import { FlexBox } from "@brg/ui";

import {
  CheckBoxWrapper,
  RadioInputSource,
  RadioBox,
  RadioCircle
} from './styles'

const RadioButton = ({ children, ...props } : any) => {
  return (
    <CheckBoxWrapper disabled={props.disabled}>
      <FlexBox width="100%">
        <RadioInputSource {...props as any} type={'radio'}/>
        <RadioBox {...props as any}>
          <RadioCircle {...props as any} />
          <FlexBox width="100%">
            {children}
          </FlexBox>
        </RadioBox>
      </FlexBox>
    </CheckBoxWrapper>
  )
}

export default RadioButton;